import { render, staticRenderFns } from "./ExcDropdown.vue?vue&type=template&id=70cd45f2&"
import script from "./ExcDropdown.vue?vue&type=script&lang=js&"
export * from "./ExcDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports